import { info_tab, preview_tab } from '../../../../../../views/contract/template';

export default {
  title: 'Modelo de contrato',
  tabs: {
    [info_tab]: 'Info',
    [preview_tab]: 'Pré-visualização',
  },
  sections: {
    subscription: 'Subscrição',
    setup_cost: 'Custo de configuração',
    preview: 'Pré-visualização',
  },
  form: {
    has_trial: {
      label: 'Adicionar dias de teste',
    },
    trial_days: {
      label: 'Dias de teste gratuitos',
      placeholder: '7',
      validation: {
        required: 'Os dias de teste são obrigatórios',
        min: '{{value}} é o valor mínimo para os dias de teste',
      },
    },
  },
  buttons: {
    apply: 'Aplicar alterações',
    download: 'Descarregar',
    apply_changes: 'Aplicar alterações',
  },
  files: {
    contract: '{{provider}}-contract-template-{{company}}.pdf',
  },
  toasts: {
    failed_to_load_data: 'Erro ao carregar pré-visualização',
  },
};
